import React from 'react';
import { useTranslation } from 'react-i18next';
import { Home, Book, Target, User } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

export function BottomNav({ hidden = false }) {
  const { t } = useTranslation();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { icon: Home, label: 'navigation.home', path: '/app' },
    { icon: Book, label: 'navigation.journal', path: '/app/journal' },
    { icon: Target, label: 'navigation.goals', path: '/app/goals' },
    { icon: User, label: 'navigation.profile', path: '/app/profile' },
    // { icon: User, label: 'navigation.profile', path: '/app/notifications' },

  ];

  return (
    <motion.nav
      initial={{ y: 100 }}
      animate={{ y: hidden ? 100 : 0 }}
      transition={{ type: "spring", stiffness: 260, damping: 20 }}
      className="fixed bottom-0 left-0 right-0 z-50 backdrop-blur-lg bg-white/90 dark:bg-gray-900/90 border-t border-gray-200/50 dark:border-gray-800/50 pb-safe"
    >
      <div className="grid grid-cols-4 h-16 px-2">
        {navItems.map(({ icon: Icon, label, path }) => {
          const active = isActive(path);

          return (
            <Link
              key={path}
              to={path}
              className="relative flex flex-col items-center justify-center group"
            >
              <div className="relative">
                {active && (
                  <motion.div
                    layoutId="bottomNav"
                    className="absolute inset-0 -m-2 bg-blue-100 dark:bg-blue-900/30 rounded-xl"
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                  />
                )}
                <Icon
                  className={`w-6 h-6 relative z-10 transition-transform duration-200 group-hover:scale-110 
                    ${active
                      ? 'text-blue-600 dark:text-blue-400'
                      : 'text-gray-600 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-gray-200'
                    }`}
                />
              </div>

              <span
                className={`text-xs mt-1 transition-colors
                  ${active
                    ? 'text-blue-600 dark:text-blue-400 font-medium'
                    : 'text-gray-600 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-gray-200'
                  }`}
              >
                {t(label)}
              </span>

              {active && (
                <motion.div
                  layoutId="activeIndicator"
                  className="absolute -top-0.5 w-1 h-1 rounded-full bg-blue-600 dark:bg-blue-400"
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
              )}

              <div className="absolute inset-0 rounded-xl bg-gray-400/0 dark:bg-gray-600/0 transition-colors group-hover:bg-gray-400/10 dark:group-hover:bg-gray-600/10" />
            </Link>
          );
        })}
      </div>
    </motion.nav>
  );
}

export default BottomNav;
